import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';
import { Config } from '../../../config/config';
import { VnptHttpService } from '../../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { DMLoaiCoQuan } from './dm-loai-co-quan';
@Injectable()
export class DMLoaiCoQuanService {

    controller:string = 'DM_LoaiCoQuan';
    constructor(private http: Http) { }
    

    GetList(paging:number,maxSize:number, keyword: string) {
        let headers = new Headers();
        let currentPage = paging;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetList?offset="+ currentPage+"&pageSize="+ maxSize + "&keyword=" + keyword, { headers: headers }).map(resp => resp.json());       
    }
    DanhSachLoaiCoQuan(paging:number, maxSize:number, keyword: string) {
        let headers = new Headers();
        let currentPage = paging;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/DanhSachNhomCoQuan?offset="+ currentPage+"&pageSize="+ maxSize + "&keyword=" + keyword , { headers: headers }).map(resp => resp.json());       
    }
    GetListDSNhomCQ(item:DMLoaiCoQuan) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/GetListDSNhomCoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    
    GetListDSNhomCQTheoCoQuan(item:DMLoaiCoQuan) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/GetListDSNhomCoQuanTheoCoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    GetListDSNhomCQTheoLCQ(item:DMLoaiCoQuan) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/DSNhomCoQuanTheoLCQ', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Save(item:DMLoaiCoQuan) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    SaveNhomCoQuan(item:DMLoaiCoQuan) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/SaveNhomCoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    Delete(item:DMLoaiCoQuan) {
        item.TrangThai = 0;
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSachCQNCQ(item:DMLoaiCoQuan) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/DSCoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/he-thong/dm-loai-co-quan/dm-loai-co-quan.service.ts